import * as S from './style';

export default function Template({
  report,
  project,
  certificate,
  downloadCertificate,
  share,
}) {
  return (
    <S.Wrapper>
      <S.Report>{report} </S.Report>
      <S.Divider />
      <S.GraduateResult>
        {project}
        <S.MobileDivider />
        {certificate}
      </S.GraduateResult>
      {downloadCertificate}
      <S.Divider />
      <S.MobileDivider />
      <S.Share>{share}</S.Share>
    </S.Wrapper>
  );
}
